// extracted by mini-css-extract-plugin
export default {"Invalid":"Invalid_Invalid__7FPJE","Text":"Invalid_Text__tlaum"};